<template>
    <form class="form">
        <div class="form__item">
            <div class="row">
                <div class="range__container form__item__range__container ">
                    <h1 class="form__item__range__value">{{question.answer || '-'}} <span>/10</span></h1>
                    <input class="range form__item__range" type="range" v-model="question.answer" min="1" max="10" step="1" :disabled="locked">
                </div>
            </div>
        </div>
    </form>
</template>

<style lang="scss" scoped>
.form__item__range__container {
    width: 95%;

    .form__item__range {
        width: 100%;
    }

    .form__item__range__value {
        float: right;
        margin: 0;
        margin-bottom: 1rem;
    }
}
</style>


<script>
    import Vue from 'vue';
    import { Component, Prop, Model } from 'vue-property-decorator';

    @Component
    export default class SurveyTemplateQuestionForm extends Vue {
        @Model('change', { type: Object, default() {
            return {
                answer: 5
            };
        }})
        question;

        @Prop() locked;
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/survey/SurveyQuestionScaleForm.vue